module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_document_remoteEntry_mjs_6e84a6cb__;